/*
 * Copyright (c) 2023. Haodong JU
 */
import { initializeApp } from 'firebase/app'

import { getFirestore } from 'firebase/firestore'

const onlineOrderFirebaseConfig = {
  apiKey: 'AIzaSyDnlXhMVxLIIWPAt3zqrC1bdrhP1ZMxwWE',
  authDomain: 'aaden-online-order.firebaseapp.com',
  projectId: 'aaden-online-order',
  storageBucket: 'aaden-online-order.firebasestorage.app',
  messagingSenderId: '35511673943',
  appId: '1:35511673943:web:0a49cc6b61fb4f96f2ef12',
  measurementId: 'G-G2JET1PGPK'
}
export const onlineOrderFirebase = initializeApp(onlineOrderFirebaseConfig, 'onlineOrderFirebaseConfig')
export const onlineOrderFirebaseStore = getFirestore(onlineOrderFirebase)
